import Skeleton from "@mui/material/Skeleton"
import { styled } from "@mui/material/styles"

export const StyledSkeleton = styled(Skeleton)({
  borderRadius: "4px"
})
